var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tooltip)?_c('KvTooltip',{attrs:{"text":_vm.tooltip,"placement":"top"}},[_c('KvChip',{attrs:{"color":_vm.badge.color,"density":"extra-compact"}},[_vm._v("\n    "+_vm._s(_vm.badge.label)+"\n  ")])],1):_c('KvChip',{attrs:{"color":_vm.badge.color,"density":"extra-compact"}},[_vm._v("\n  "+_vm._s(_vm.badge.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }